import { uniq } from 'lodash';

import { WishlistList } from '@notino/shared/definitions/types';

export const getWishlistTotalCount = ({
  lists: _lists,
  webIds = [],
  addedToLists,
  removeFromLists,
}: {
  lists: WishlistList[] | null | undefined;
  webIds?: number[];
  addedToLists?: { id: string }[];
  removeFromLists?: { id: string }[];
}) => {
  let lists = _lists ?? [];

  if (addedToLists && addedToLists.length > 0) {
    addedToLists.forEach(({ id }) => {
      const foundList = lists.find((list) => list.id === id);
      if (!foundList) {
        lists = [...lists, { id, name: '', products: webIds }];
        return;
      }

      lists = lists.map((list) =>
        list.id === id
          ? { ...list, products: [...(list.products ?? []), ...webIds] }
          : list
      );
    });
  }

  if (removeFromLists && removeFromLists.length > 0) {
    removeFromLists.forEach(({ id }) => {
      const foundList = lists.find((list) => list.id === id);
      if (!foundList) {
        return;
      }
      lists = lists.map((list) =>
        list.id === id
          ? {
              ...list,
              products: (list.products ?? []).filter(
                (productId) => !webIds.includes(productId)
              ),
            }
          : list
      );
    });
  }

  const uniqueProductIds = uniq(lists.flatMap((list) => list.products || []));
  return uniqueProductIds.length;
};
